/* =========================================================
   PHESIA — theme.js
   Statik sitedeki tüm etkileşim ve animasyonlar, Shopify'ın
   Cart AJAX API'siyle birlikte çalışacak şekilde uyarlandı.

   1. Yardımcılar   2. Sepet (Shopify AJAX)   3. Bildirim
   4. Ortak arayüz  5. Hızlı bakış            6. Ürün sayfası
   7. Koleksiyon filtreleri                   8. İletişim formu
   ========================================================= */

(function () {
  'use strict';

  const T = window.PHESIA || {};
  const S = T.strings || {};

  /* ================= 1. YARDIMCILAR ================= */

  /* Shopify para birimi biçimlendirmesi (kuruş cinsinden değer alır) */
  function money(cents) {
    const format = T.moneyFormat || '${{amount}}';
    const value = (cents / 100);

    function fmt(number, decimals, thousandSep, decimalSep) {
      if (isNaN(number) || number === null) return 0;
      number = (number / 1).toFixed(decimals);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousandSep || ','));
      const cents_ = parts[1] ? (decimalSep || '.') + parts[1] : '';
      return dollars + cents_;
    }

    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholder);
    if (!match) return format;

    let out;
    switch (match[1]) {
      case 'amount': out = fmt(value, 2); break;
      case 'amount_no_decimals': out = fmt(value, 0); break;
      case 'amount_with_comma_separator': out = fmt(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(value, 0, '.', ','); break;
      case 'amount_with_space_separator': out = fmt(value, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = fmt(value, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': out = fmt(value, 2, "'", '.'); break;
      default: out = fmt(value, 2);
    }
    return format.replace(placeholder, out);
  }

  /* Görsel yüklenemezse yerel yer tutucuya düş */
  document.addEventListener('error', function (e) {
    const img = e.target;
    if (!img || img.tagName !== 'IMG' || img.dataset.fallback) return;
    img.dataset.fallback = '1';
    const ratio = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 0.8;
    const ph = T.placeholders || {};
    img.src = ratio > 1.2 ? ph.wide : (ratio > 0.95 ? ph.square : ph.portrait);
  }, true);

  /* ================= 2. SEPET (Shopify AJAX API) ================= */
  const Cart = {
    data: { items: [], item_count: 0, total_price: 0 },

    async load() {
      try {
        const res = await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } });
        this.data = await res.json();
      } catch (e) { /* sessizce geç */ }
      this.render();
    },

    async add(variantId, qty, propertiesText) {
      const body = { items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] };
      const res = await fetch(T.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const json = await res.json();
      if (json.status) { toast(json.description || json.message); return false; }
      await this.load();
      toast('"' + (json.items ? json.items[0].product_title : propertiesText || '') + '" ' + (S.addedToCart || 'added to your cart'));
      const btn = document.getElementById('cart-open');
      if (btn) { btn.classList.add('bump'); setTimeout(() => btn.classList.remove('bump'), 500); }
      return true;
    },

    async change(key, qty) {
      const res = await fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Number(qty) })
      });
      this.data = await res.json();
      /* Sepet sayfasındaysak sunucu tarafı toplamlar için sayfayı tazele */
      if (document.body.dataset.page === 'cart') { window.location.reload(); return; }
      this.render();
    },

    render() {
      const n = this.data.item_count || 0;
      const total = this.data.total_price || 0;

      document.querySelectorAll('#cart-count').forEach(e => e.textContent = n);
      const q = document.getElementById('cart-qty'); if (q) q.textContent = n;
      const t = document.getElementById('cart-total'); if (t) t.textContent = money(total);

      /* Ücretsiz kargo çubuğu */
      const LIMIT = T.freeShippingThreshold || 0;
      const bar = document.getElementById('ship-bar');
      const msg = document.getElementById('ship-msg');
      if (bar && msg && LIMIT > 0) {
        bar.style.width = Math.min(100, total / LIMIT * 100) + '%';
        msg.innerHTML = total >= LIMIT
          ? (S.freeShippingUnlocked || 'Free shipping unlocked!')
          : (S.freeShippingAway || 'You are {{ amount }} away from free shipping.').replace('{{ amount }}', money(LIMIT - total));
      }

      /* Çekmece içeriği */
      const box = document.getElementById('cart-lines');
      if (!box) return;

      if (!this.data.items || !this.data.items.length) {
        box.innerHTML = '<div class="cart-empty">' + (S.emptyCart || 'Your cart is empty.') +
          '<br><br><a class="btn btn-sm" href="/collections/all">' + (S.startShopping || 'Start shopping') + '</a></div>';
        return;
      }

      box.innerHTML = this.data.items.map(item => {
        const img = item.image ? item.image.replace(/(\.[^.]*)$/, '_200x$1') : (T.placeholders || {}).portrait;
        const variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="opt">' + item.variant_title + '</div>' : '';
        return '<div class="cart-line">' +
          '<a href="' + item.url + '"><img src="' + img + '" alt="" loading="lazy"></a>' +
          '<div class="cart-line-info">' +
            '<h4><a href="' + item.url + '">' + item.product_title + '</a></h4>' +
            variant +
            '<div class="price" style="margin-top:6px">' + money(item.final_price) + '</div>' +
            '<div>' +
              '<span class="qty">' +
                '<button type="button" data-cart-dec="' + item.key + '" data-qty="' + item.quantity + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-cart-inc="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
              '</span>' +
              '<a href="#" class="link-remove" data-cart-del="' + item.key + '">' + (S.remove || 'Remove') + '</a>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    }
  };
  window.PhesiaCart = Cart;

  /* Adet ve silme butonları — tek dinleyici */
  document.addEventListener('click', function (e) {
    const inc = e.target.closest('[data-cart-inc]');
    const dec = e.target.closest('[data-cart-dec]');
    const del = e.target.closest('[data-cart-del]');
    if (inc) { e.preventDefault(); Cart.change(inc.dataset.cartInc, Number(inc.dataset.qty) + 1); }
    if (dec) { e.preventDefault(); Cart.change(dec.dataset.cartDec, Number(dec.dataset.qty) - 1); }
    if (del) { e.preventDefault(); Cart.change(del.dataset.cartDel, 0); }
  });

  /* ================= 3. BİLDİRİM ================= */
  function toast(text) {
    const wrap = document.getElementById('toasts');
    if (!wrap || !text) return;
    const el = document.createElement('div');
    el.className = 'toast';
    el.textContent = text;
    wrap.appendChild(el);
    setTimeout(() => { el.classList.add('out'); setTimeout(() => el.remove(), 350); }, 2600);
  }
  window.phesiaToast = toast;

  /* ================= 4. ORTAK ARAYÜZ ================= */
  const ICON = {
    left: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="m15 5-7 7 7 7"/></svg>',
    right: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="m9 5 7 7-7 7"/></svg>',
    chev: '<svg class="chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="m6 9 6 6 6-6"/></svg>',
    plus: '<svg class="plus" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>'
  };

  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('open');
    document.getElementById('overlay')?.classList.add('open');
    document.body.classList.add('no-scroll');
  }
  function closeAll() {
    document.querySelectorAll('.drawer.open').forEach(d => d.classList.remove('open'));
    document.getElementById('overlay')?.classList.remove('open');
    document.getElementById('popup')?.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }
  window.phesiaOpenDrawer = openDrawer;

  /* Sayfaya sonradan eklenen bölümleri de canlandırır */
  function enhance() {
    document.querySelectorAll('.acc-item > button').forEach(b => {
      if (!b.querySelector('svg')) b.insertAdjacentHTML('beforeend', ICON.plus);
    });
    document.querySelectorAll('.filter-group > button:not([data-bound])').forEach(b => {
      b.dataset.bound = '1'; b.insertAdjacentHTML('beforeend', ICON.chev);
    });
    document.querySelectorAll('[data-prev]').forEach(b => { if (!b.innerHTML.trim()) b.innerHTML = ICON.left; });
    document.querySelectorAll('[data-next]').forEach(b => { if (!b.innerHTML.trim()) b.innerHTML = ICON.right; });

    document.querySelectorAll('.carousel:not([data-bound])').forEach(car => {
      car.dataset.bound = '1';
      const track = car.querySelector('.carousel-track');
      if (!track) return;
      const scope = car.closest('section') || document;
      const prev = scope.querySelector('[data-prev]');
      const next = scope.querySelector('[data-next]');
      const bar = car.querySelector('.carousel-bar span');
      const step = () => (track.querySelector('*')?.offsetWidth || 300) + 18;
      prev?.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
      const upd = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (bar) {
          const w = Math.max(12, track.clientWidth / track.scrollWidth * 100);
          bar.style.width = w + '%';
          bar.style.left = (max ? track.scrollLeft / max : 0) * (100 - w) + '%';
        }
        if (prev) prev.disabled = track.scrollLeft < 5;
        if (next) next.disabled = track.scrollLeft > max - 5;
      };
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });

    if (window.revealScan) window.revealScan();
    if (window.countScan) window.countScan();
  }
  window.phesiaEnhance = enhance;

  function initUI() {
    Cart.load();

    document.getElementById('cart-open')?.addEventListener('click', e => {
      e.preventDefault();
      openDrawer('cart-drawer');
    });
    document.getElementById('burger')?.addEventListener('click', () => openDrawer('menu-drawer'));
    document.getElementById('overlay')?.addEventListener('click', closeAll);
    document.addEventListener('click', e => { if (e.target.closest('[data-close],[data-close-popup]')) closeAll(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

    /* Mobil menü akordeonu */
    document.addEventListener('click', e => {
      const t = e.target.closest('.m-toggle');
      if (t) t.parentElement.classList.toggle('open');
    });

    /* Footer sütunları mobilde akordeon */
    document.addEventListener('click', e => {
      const h = e.target.closest('.f-col > h5');
      if (h && window.innerWidth <= 768) h.parentElement.classList.toggle('open');
    });

    /* Çekmece / pop-up içindeki linke tıklanınca kapat */
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (a && a.closest('.drawer, .popup') && !a.dataset.cartDel) setTimeout(closeAll, 60);
    });

    /* Yan kampanya sekmesini kapat */
    document.querySelector('.side-close')?.addEventListener('click', () => {
      document.getElementById('side-tab')?.classList.add('hidden');
    });

    /* Kategori seçicisi: masaüstünde uzun, mobilde kısa */
    const catSel = document.getElementById('search-cat');
    const fitCatLabel = () => {
      if (catSel && catSel.options[0]) {
        catSel.options[0].textContent = window.innerWidth <= 768 ? 'All' : 'All Categories';
      }
    };
    fitCatLabel();
    window.addEventListener('resize', fitCatLabel);

    /* Arama formu: seçilen kategori varsa sorguya eklenir */
    document.getElementById('search-form')?.addEventListener('submit', e => {
      const input = document.getElementById('search-input');
      if (catSel && catSel.value && input && input.value.indexOf(catSel.value) === -1) {
        input.value = (input.value + ' ' + catSel.value).trim();
      }
    });

    /* Bülten formu doğrulaması */
    document.querySelectorAll('.js-newsletter').forEach(f => {
      f.addEventListener('submit', e => {
        const input = f.querySelector('input[type=email]');
        const msg = f.querySelector('.form-msg');
        const ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value);
        if (!ok) {
          e.preventDefault();
          if (msg) { msg.style.color = 'var(--primary)'; msg.textContent = 'Please enter a valid email address.'; }
        }
      });
    });

    /* Yukarı çık + yapışkan header */
    const header = document.getElementById('header');
    const toTop = document.getElementById('to-top');
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      toTop?.classList.toggle('show', y > 500);
      if (header) {
        header.classList.toggle('is-stuck', y > 10);
        header.classList.toggle('is-hidden', y > last && y > 400);
      }
      last = y;
    }, { passive: true });
    toTop?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

    /* Kaydırınca beliren animasyon */
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: .12, rootMargin: '0px 0px -40px' });
    window.revealScan = () => document.querySelectorAll('[data-reveal]:not(.in)').forEach((el, i) => {
      el.style.transitionDelay = (i % 6) * 60 + 'ms';
      io.observe(el);
    });

    /* Sayı sayaçları */
    const co = new IntersectionObserver(es => es.forEach(en => {
      if (!en.isIntersecting) return;
      const el = en.target, target = +el.dataset.count, dur = 1400;
      let t0 = null;
      const step = ts => {
        if (!t0) t0 = ts;
        const p = Math.min(1, (ts - t0) / dur);
        el.textContent = Math.floor(target * (1 - Math.pow(1 - p, 3))).toLocaleString();
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      co.unobserve(el);
    }), { threshold: .5 });
    window.countScan = () => document.querySelectorAll('[data-count]:not([data-counted])').forEach(el => {
      el.dataset.counted = '1'; co.observe(el);
    });

    /* Akordeonlar */
    document.addEventListener('click', e => {
      const accBtn = e.target.closest('.acc-item > button');
      if (accBtn) accBtn.parentElement.classList.toggle('open');
      const fBtn = e.target.closest('.filter-group > button');
      if (fBtn) fBtn.parentElement.classList.toggle('open');
    });

    /* Sekmeler */
    document.addEventListener('click', e => {
      const tab = e.target.closest('.tab');
      if (!tab) return;
      const wrap = tab.closest('[data-tabs]');
      if (!wrap) return;
      wrap.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
      wrap.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      wrap.querySelector('#' + tab.dataset.target)?.classList.add('active');
      enhance();
    });

    /* Kart üzerindeki renk kutucukları */
    document.addEventListener('click', e => {
      const sw = e.target.closest('.product-card .swatch');
      if (sw) {
        sw.parentElement.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
        sw.classList.add('active');
      }
    });

    /* Kupon kodu kopyalama */
    document.getElementById('copy-code')?.addEventListener('click', function () {
      const code = this.dataset.code || '';
      navigator.clipboard?.writeText(code).catch(() => { });
      this.classList.add('copied');
      setTimeout(() => this.classList.remove('copied'), 1600);
      toast('Coupon code copied: ' + code);
    });

    initCountdown();
    initHeroSlider();
    enhance();
  }

  /* Geri sayım */
  function initCountdown() {
    const box = document.getElementById('countdown');
    if (!box) return;
    let end;
    if (box.dataset.end) {
      end = new Date(box.dataset.end + 'T23:59:59');
    }
    if (!end || isNaN(end)) {
      end = new Date();
      end.setDate(end.getDate() + (Number(box.dataset.days) || 3));
      end.setHours(23, 59, 59, 0);
    }
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const d = Math.max(0, end - new Date());
      const dd = Math.floor(d / 864e5), hh = Math.floor(d / 36e5) % 24,
            mm = Math.floor(d / 6e4) % 60, ss = Math.floor(d / 1e3) % 60;
      box.innerHTML = [dd, hh, mm, ss].map(v => '<span class="cd-box">' + pad(v) + '</span>').join('<span class="cd-sep">:</span>');
    };
    tick();
    setInterval(tick, 1000);
  }

  /* Hero slayt gösterisi */
  function initHeroSlider() {
    const slides = document.querySelectorAll('.hero-slide');
    const dots = document.getElementById('hero-dots');
    if (slides.length < 2 || !dots) return;
    let idx = 0;
    dots.innerHTML = Array.from(slides).map((_, i) =>
      '<button type="button" class="' + (i ? '' : 'active') + '" aria-label="Slide ' + (i + 1) + '"></button>').join('');
    const go = i => {
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('active', k === idx));
      dots.querySelectorAll('button').forEach((b, k) => b.classList.toggle('active', k === idx));
    };
    dots.querySelectorAll('button').forEach((b, i) => b.addEventListener('click', () => go(i)));
    setInterval(() => go(idx + 1), 5000);
  }

  /* ================= 5. HIZLI BAKIŞ ================= */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-quick]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.quick;
    try {
      const res = await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } });
      const p = await res.json();
      openQuickView(p);
    } catch (err) {
      window.location.href = '/products/' + handle;
    }
  });

  function openQuickView(p) {
    const pop = document.getElementById('popup');
    if (!pop) return;
    const card = pop.querySelector('.popup-card');
    const img = p.featured_image ? p.featured_image.replace(/(\.[^.]*)$/, '_800x$1') : (T.placeholders || {}).portrait;

    const optionsHtml = (p.options || []).map((opt, oi) => {
      const name = typeof opt === 'string' ? opt : opt.name;
      const values = typeof opt === 'string' ? p.options_with_values?.[oi]?.values || [] : opt.values;
      const lower = (name || '').toLowerCase();
      const isColor = lower === 'color' || lower === 'colour' || lower === 'renk';
      if (!values || !values.length) return '';
      return '<div class="opt-block"><h5>' + name + '</h5>' +
        (isColor
          ? '<div class="swatches qv-opt" data-index="' + oi + '">' + values.map((v, i) =>
              '<span class="swatch' + (i ? '' : ' active') + '" data-value="' + v + '" title="' + v + '" style="background:' +
              String(v).toLowerCase().replace(/\s/g, '') + ';width:28px;height:28px;border-radius:50%"></span>').join('') + '</div>'
          : '<div class="size-opts qv-opt" data-index="' + oi + '">' + values.map((v, i) =>
              '<button type="button" class="size-opt' + (i ? '' : ' active') + '" data-value="' + v + '">' + v + '</button>').join('') + '</div>') +
        '</div>';
    }).join('');

    const priceHtml = p.compare_at_price && p.compare_at_price > p.price
      ? '<span style="color:var(--primary)">' + money(p.price) + '</span><span class="old">' + money(p.compare_at_price) + '</span>'
      : money(p.price);

    card.innerHTML =
      '<img src="' + img + '" alt="' + p.title + '">' +
      '<div class="popup-content" style="text-align:left">' +
        '<button class="close-btn" data-close-popup aria-label="Close">' + ICON.close + '</button>' +
        (p.type ? '<span class="eyebrow">' + p.type + '</span>' : '') +
        '<h2 style="margin:8px 0 6px">' + p.title + '</h2>' +
        '<div class="pdp-price">' + priceHtml + '</div>' +
        optionsHtml +
        '<button class="btn btn-block" id="qv-add">' + (S.addToCart || 'Add to Cart') + '</button>' +
        '<a href="/products/' + p.handle + '" class="btn btn-block btn-outline" style="margin-top:10px">' +
          (S.viewDetails || 'View Full Details') + '</a>' +
      '</div>';

    /* Seçenek seçimi */
    const selected = (p.options || []).map((opt, oi) => {
      const values = typeof opt === 'string' ? [] : opt.values;
      return values && values.length ? values[0] : null;
    });

    card.querySelectorAll('.qv-opt').forEach(group => {
      group.addEventListener('click', ev => {
        const el = ev.target.closest('.size-opt, .swatch');
        if (!el) return;
        group.querySelectorAll('.size-opt, .swatch').forEach(x => x.classList.remove('active'));
        el.classList.add('active');
        selected[Number(group.dataset.index)] = el.dataset.value;
      });
    });

    card.querySelector('#qv-add')?.addEventListener('click', async () => {
      const variant = (p.variants || []).find(v =>
        selected.every((val, i) => val === null || v.options[i] === val)) || p.variants[0];
      if (!variant) return;
      if (variant.available === false) { toast(S.soldOut || 'Sold out'); return; }
      const ok = await Cart.add(variant.id, 1, p.title);
      if (ok) { closeAll(); setTimeout(() => openDrawer('cart-drawer'), 200); }
    });

    pop.classList.add('open');
    document.body.classList.add('no-scroll');
  }

  /* ================= 6. ÜRÜN SAYFASI ================= */
  function initProductPage() {
    const pdp = document.getElementById('pdp');
    if (!pdp) return;

    /* Galeri */
    const stage = document.getElementById('stage');
    const stageImg = stage?.querySelector('img');
    document.getElementById('thumbs')?.addEventListener('click', e => {
      const b = e.target.closest('button');
      if (!b || !stageImg) return;
      document.querySelectorAll('#thumbs button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      stageImg.style.opacity = 0;
      setTimeout(() => { stageImg.src = b.dataset.full; stageImg.style.opacity = 1; }, 150);
    });

    /* Fareyle büyütme */
    if (stage && stageImg) {
      stage.addEventListener('mousemove', e => {
        const r = stage.getBoundingClientRect();
        stageImg.style.transformOrigin =
          ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      stage.addEventListener('mouseenter', () => stage.classList.add('zoom'));
      stage.addEventListener('mouseleave', () => stage.classList.remove('zoom'));
    }

    /* Varyant seçimi */
    const dataEl = document.getElementById('variant-data');
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const idInput = document.getElementById('variant-id');
    const priceBox = document.getElementById('pdp-price');
    const addBtn = document.getElementById('pdp-add');

    function currentSelection() {
      const out = [];
      pdp.querySelectorAll('[data-option-index]').forEach(group => {
        const active = group.querySelector('.active');
        out[Number(group.dataset.optionIndex)] = active ? active.dataset.value : null;
      });
      return out;
    }

    function syncVariant() {
      const sel = currentSelection();
      const variant = variants.find(v => sel.every((val, i) => val === null || v.options[i] === val));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceBox) {
        priceBox.innerHTML = variant.compare_at_price && variant.compare_at_price > variant.price
          ? '<span style="color:var(--primary)">' + money(variant.price) + '</span><span class="old">' + money(variant.compare_at_price) + '</span>'
          : money(variant.price);
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? (S.addToCart || 'Add to Cart') : (S.soldOut || 'Sold out');
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    pdp.querySelectorAll('[data-option-index]').forEach(group => {
      group.addEventListener('click', e => {
        const el = e.target.closest('.size-opt, .swatch');
        if (!el) return;
        group.querySelectorAll('.size-opt, .swatch').forEach(x => x.classList.remove('active'));
        el.classList.add('active');
        syncVariant();
      });
    });

    /* Adet */
    let qty = 1;
    const qVal = document.getElementById('q-val');
    const qInput = document.getElementById('quantity-input');
    const setQty = v => { qty = Math.max(1, v); if (qVal) qVal.textContent = qty; if (qInput) qInput.value = qty; };
    document.getElementById('q-inc')?.addEventListener('click', () => setQty(qty + 1));
    document.getElementById('q-dec')?.addEventListener('click', () => setQty(qty - 1));

    /* Sepete ekleme — çekmece açılır, sayfa yenilenmez */
    document.getElementById('product-form')?.addEventListener('submit', async e => {
      e.preventDefault();
      const ok = await Cart.add(idInput.value, qty, document.querySelector('#pdp h1')?.textContent);
      if (ok) openDrawer('cart-drawer');
    });
  }

  /* ================= 7. KOLEKSİYON FİLTRELERİ ================= */
  function initCollectionPage() {
    const form = document.getElementById('facet-form');
    if (!form) return;

    /* Filtre değişince formu gönder (Shopify facet URL'i oluşturur) */
    form.addEventListener('change', e => {
      if (e.target.matches('input[type=checkbox], input[type=range], select')) form.submit();
    });

    /* Renk kutucukları görsel geri bildirim */
    form.querySelectorAll('.color-opt input').forEach(inp => {
      inp.addEventListener('change', () => inp.parentElement.classList.toggle('active', inp.checked));
    });

    /* Fiyat aralığı etiketi */
    const range = document.getElementById('f-price');
    const label = document.getElementById('price-val');
    if (range && label) {
      range.addEventListener('input', () => { label.textContent = money(range.value * 100); });
    }

    /* Sıralama */
    document.getElementById('sort')?.addEventListener('change', () => form.submit());
  }

  /* ================= 8. İLETİŞİM FORMU ================= */
  function initContactForm() {
    const form = document.getElementById('contact-form');
    if (!form) return;
    form.addEventListener('submit', e => {
      let ok = true;
      form.querySelectorAll('[required]').forEach(el => {
        const field = el.closest('.field');
        const valid = el.type === 'email'
          ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.value)
          : el.value.trim().length > 2;
        field?.classList.toggle('invalid', !valid);
        if (!valid) ok = false;
      });
      if (!ok) e.preventDefault();
    });
  }

  /* ================= BAŞLAT ================= */
  function boot() {
    initUI();
    initProductPage();
    initCollectionPage();
    initContactForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Tema düzenleyicide bölüm yeniden yüklendiğinde tekrar canlandır */
  document.addEventListener('shopify:section:load', () => {
    enhance();
    initCountdown();
    initHeroSlider();
    initProductPage();
    initCollectionPage();
    initContactForm();
  });
})();
